import React, { useState, useEffect, useCallback, useRef } from 'react';
import { Row, Col } from 'react-bootstrap';
import MetricsCards from '../components/MetricsCards';
import ResolutionsChart from '../components/ResolutionsChart';
import AgentFilterSelect from '../components/AgentFilterSelect';
import { useDashboardMetrics } from './hooks/useDashboardMetrics';
import useToken from 'hooks/useToken';

const DashboardView = () => {
  const { token, nombreCompleto, idUsuario } = useToken();
  const [selectedAgentId, setSelectedAgentId] = useState(idUsuario ? String(idUsuario) : '');
  const hasInitializedAgentRef = useRef(Boolean(idUsuario));

  // Sincronizar el idUsuario por defecto solo una vez si el token tarda en hidratarse
  useEffect(() => {
    if (idUsuario && !hasInitializedAgentRef.current) {
      setSelectedAgentId(String(idUsuario));
      hasInitializedAgentRef.current = true;
    }
  }, [idUsuario]);

  const [agents, setAgents] = useState([]);
  const [isLoadingAgents, setIsLoadingAgents] = useState(false);
  const isFetchingAgentsRef = useRef(false);

  // Cargar lista de agentes activos para el selector
  const fetchAgents = useCallback(async () => {
    if (!token || isFetchingAgentsRef.current) return;
    isFetchingAgentsRef.current = true;
    setIsLoadingAgents(true);
    try {
      const response = await fetch('/api/SupportEngine/GetAgentsList', {
        headers: { Accept: 'application/json', Authorization: 'Bearer ' + token }
      });
      if (response.ok) {
        const result = await response.json();
        const data = result.data || (Array.isArray(result) ? result : []);
        setAgents(Array.isArray(data) ? data : []);
      }
    } catch {
      // Silencioso
    } finally {
      isFetchingAgentsRef.current = false;
      setIsLoadingAgents(false);
    }
  }, [token]);

  useEffect(() => {
    fetchAgents();
  }, [fetchAgents]);

  const { metrics, isLoading, isWeekLoading, fetchWeeklyMetrics } = useDashboardMetrics(selectedAgentId);

  return (
    <div>
      {/* Title Header with Agent Filter */}
      <div className="d-flex justify-content-between align-items-start align-items-md-center mb-4 flex-column flex-md-row gap-3">
        <div className="se-dashboard-header-card">
          <h3 className="fw-bold text-900 mb-1" style={{ fontSize: '1.6rem' }}>
            Visión General
          </h3>
          <p className="text-500 mb-0" style={{ fontSize: '0.90rem', color: '#64748b' }}>
            Métricas en tiempo real de la operación de soporte por WhatsApp.
          </p>
        </div>

        <div className="se-agent-filter-card-wrapper">
          <AgentFilterSelect
            variant="card"
            selectedAgentId={selectedAgentId}
            onSelectAgent={setSelectedAgentId}
            agents={agents}
            currentUserId={idUsuario}
            currentUserName={nombreCompleto}
            isLoadingAgents={isLoadingAgents}
          />
        </div>
      </div>

      {/* 4 KPI Cards + 2 SLA Cards */}
      <MetricsCards data={metrics} isLoading={isLoading} />

      {/* Chart */}
      <Row className="g-3">
        <Col xs={12}>
          <ResolutionsChart
            hourlyData={metrics.hourlyResolutions}
            weeklyTrend={metrics.weeklyTrend}
            isLoading={isLoading}
            isWeeklyLoading={isWeekLoading}
            onRequireWeekly={fetchWeeklyMetrics}
          />
        </Col>
      </Row>
    </div>
  );
};

export default DashboardView;

